<template>
  <!-- Mobile: Full screen dialog -->
  <q-dialog 
    v-if="isMobile" 
    :model-value="visible"
    @update:model-value="handleUpdate"
    @hide="handleHide"
    maximized 
    position="standard"
  >
    <q-card class="about-dialog">
      <q-card-section class="row items-center q-pb-none q-pt-md q-px-md">
        <q-btn flat round icon="arrow_back" @click="goBack" class="q-mr-sm" />
        <div class="text-h6 text-weight-medium text-grey-8">{{$t('About')}}</div>
        <q-space />
      </q-card-section>
      
      <q-card-section class="q-pa-sm">
        <AboutContent @item-click="handleItemClick" />
      </q-card-section>
    </q-card>
  </q-dialog>

  <!-- Desktop: Dialog -->
  <q-dialog 
    v-else 
    :model-value="visible"
    @update:model-value="handleUpdate"
    @hide="handleHide"
    position="standard"
  >
    <q-card class="about-dialog">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6 text-grey-8">{{$t('About')}}</div>
        <q-space />
        <q-btn flat round dense icon="close" @click="goBack" />
      </q-card-section>
      
      <q-card-section class="q-pa-sm">
        <AboutContent @item-click="handleItemClick" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { useQuasar } from 'quasar'
import AboutContent from '@/specific/components/app/about-content.vue'

const $q = useQuasar()

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['back', 'about-click', 'privacy-click', 'terms-click'])

const isMobile = computed(() => $q.screen.lt.md)

const handleUpdate = (value) => {
  console.log('Dialog update:model-value', value)
  if (!value) {
    emit('back')
  }
}

const handleHide = () => {
  console.log('Dialog hide event')
  emit('back')
}

const goBack = () => {
  emit('back')
}

const handleItemClick = (type) => {
  emit(`${type}-click`)
}
</script>

<style lang="scss" scoped>
.text-grey-8 {
  body.body--dark & {
    color: white !important;
  }
}
</style>